import React from 'react';
import { useTheme } from '../context/ThemeContext';
import logo from '../images/logomark_fiducia.png';
import { brandColors, brandColorsTwo } from '../utils/data';
import { Box, Typography } from '@mui/material';

const Home = () => {
  const { theme } = useTheme();

  return (
    <div className="main-content page-home">
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          maxHeight: '100%',
          minHeight: '100%'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 2
          }}
        >
          <Box
            component="img"
            src={logo}
            alt="Veritas"
            sx={{
              width: 111,
              height: 111,
              objectFit: 'contain'
            }}
          />
          
          <Typography
            variant="body2"
            sx={{
              fontSize: 12,
              color: 'text.secondary'
            }}
          >
            launching <span style={{ color: `${brandColors.blue} !important` }}>Fall 2026</span>
          </Typography>

          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              gap: 1,
              mb: 2
            }}
          >
            {Object.keys(brandColors).map((color, index) => (
              <Box
                key={`swatch${index}`}
                sx={{
                  width: 22,
                  height: 7,
                  backgroundColor: brandColors[color],
                  borderRadius: 1
                }}
              />
            ))}

            {Object.keys(brandColorsTwo).map((color, index) => (
              <Box
                key={`swatch${index}`}
                sx={{
                  width: 22,
                  height: 7,
                  backgroundColor: brandColorsTwo[color],
                  borderRadius: 1
                }}
              />
            ))}
          </Box>
        </Box>
      </Box>
    </div>
  );
};

export default Home; 